/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrderCancelationStatusQueryVariables = Exact<{
  id: string | number;
}>;

export type OrderCancelationStatusQuery = {
  readonly orderStatus:
    | { readonly __typename: 'OrderStatus'; readonly canceledStatus: string | null }
    | Record<PropertyKey, never>
    | null;
};

export const OrderCancelationStatusDocument = gql`
  query OrderCancelationStatus($id: ID!) {
    orderStatus(orderId: $id) {
      ... on OrderStatus {
        __typename
        canceledStatus
      }
    }
  }
`;

export function useOrderCancelationStatusQuery(
  options: Omit<Urql.UseQueryArgs<OrderCancelationStatusQueryVariables>, 'query'>,
) {
  return Urql.useQuery<OrderCancelationStatusQuery, OrderCancelationStatusQueryVariables>({
    query: OrderCancelationStatusDocument,
    ...options,
  });
}
